import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

interface MarkConversationReadPayload {
  company_id: string;
  subscription_id: string;
  phone: string;
  read: boolean;
}

export async function markConversationRead(
  payload: MarkConversationReadPayload,
  auth: Authentication,
): Promise<void> {
  try {
    if (!payload.company_id || !payload.subscription_id || !payload.phone) {
      throw new MarkConversationReadFailure('company_id, subscription_id et phone sont requis');
    }

    await HttpClient.post('/company/conversations/read', payload, auth.token);
  } catch (e) {
    console.error('markConversationRead error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new MarkConversationReadFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new MarkConversationReadFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class MarkConversationReadFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
